var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"ui-status",class:_vm.statusName},[_c('span',{staticClass:"ui-status_rect"}),_c('span',{staticClass:"ui-status_text"},[_vm._v(_vm._s(_vm.statusName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }